module.exports = __webpack_public_path__ + "static/media/25.b50a122c.jpg";